import { VoteAlert } from './components/vote-alert';

export default function Welcome() {
  return (
    <div className='relative bg-gray-50 overflow-hidden'>
      <div
        className='hidden sm:block sm:absolute sm:inset-y-0 sm:h-full sm:w-full'
        aria-hidden='true'
      >
        <div className='relative h-full max-w-7xl mx-auto'>
          <svg
            className='absolute right-full transform translate-y-1/4 translate-x-1/4 lg:translate-x-1/2'
            width={404}
            height={784}
            fill='none'
            viewBox='0 0 404 784'
            aria-label='Decorative background pattern'
          >
            <title>Decorative background pattern</title>
            <defs>
              <pattern
                id='f210dbf6-a58d-4871-961e-36d5016a0f49'
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits='userSpaceOnUse'
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className='text-gray-200'
                  fill='currentColor'
                />
              </pattern>
            </defs>
            <rect width={404} height={784} fill='url(#f210dbf6-a58d-4871-961e-36d5016a0f49)' />
          </svg>
          <svg
            className='absolute left-full transform -translate-y-3/4 -translate-x-1/4 md:-translate-y-1/2 lg:-translate-x-1/2'
            width={404}
            height={784}
            fill='none'
            viewBox='0 0 404 784'
            aria-label='Decorative background pattern'
          >
            <title>Decorative background pattern</title>
            <defs>
              <pattern
                id='5d0dd344-b041-4d26-bec4-8d33ea57ec9b'
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits='userSpaceOnUse'
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className='text-gray-200'
                  fill='currentColor'
                />
              </pattern>
            </defs>
            <rect width={404} height={784} fill='url(#5d0dd344-b041-4d26-bec4-8d33ea57ec9b)' />
          </svg>
        </div>
      </div>

      <div className='relative pt-6 pb-16 sm:pb-24'>
        <main className='mt-16 mx-auto max-w-7xl px-4 sm:mt-24'>
          <div className='text-center'>
            <VoteAlert />
            <h1 className='text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl'>
              <span className='block xl:inline'>Welcome to your</span>{' '}
              <span className='block text-blue-600 xl:inline'>RM Workspace</span>
            </h1>
            <p className='mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl'>
              Data and tools at your fingertips, to help you work more strategically and
              efficiently.
            </p>
            <div className='mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8'>
              <div className='rounded-md shadow'>
                <a
                  href='/dashboard/overview'
                  className='w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10'
                >
                  Dashboards
                </a>
              </div>
              <div className='mt-3 rounded-md shadow sm:mt-0 sm:ml-3'>
                <a
                  href='/reports'
                  className='w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10'
                >
                  Reports
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
